import { isRolloutFlagEnabled } from '@pequity/shared/utils/rollout-flags';

export const isPerformanceEvaluationsAvailable = (isHrisSyncEnabled: boolean, isLyricProvider: boolean) =>
  isRolloutFlagEnabled('ATLAS_performance_evaluations') && isHrisSyncEnabled && isLyricProvider;
